

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETREVIEWREMPLOYEEKRAKPISTATUSLIST= createAsyncThunk(
  "getReviewerEmployeeKraKpiStatusList/getReviewerEmployeeKraKpiStatusList",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getReviewerEmployeeKraKpiStatusListSlice = createSlice({
  name: "getReviewerEmployeeKraKpiStatusListSlice",
  initialState: {
    getReviewerEmployeeKraKpiStatusList: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetReviewerEmployeeKraKpiStatusList: (state) => {
        state.getReviewerEmployeeKraKpiStatusList.loading = false
        state.getReviewerEmployeeKraKpiStatusList.error = false
        state.getReviewerEmployeeKraKpiStatusList.data = []
        state.getReviewerEmployeeKraKpiStatusList.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETREVIEWREMPLOYEEKRAKPISTATUSLIST.fulfilled, (state, action) => {
      state.getReviewerEmployeeKraKpiStatusList = {
        ...state.getReviewerEmployeeKraKpiStatusList,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETREVIEWREMPLOYEEKRAKPISTATUSLIST.pending, (state, action) => {
      state.getReviewerEmployeeKraKpiStatusList = {
        ...state.getReviewerEmployeeKraKpiStatusList,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETREVIEWREMPLOYEEKRAKPISTATUSLIST.rejected, (state, action) => {
      state.getReviewerEmployeeKraKpiStatusList = {
        ...state.getReviewerEmployeeKraKpiStatusList,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getReviewerEmployeeKraKpiStatusListAction = {
    GETREVIEWREMPLOYEEKRAKPISTATUSLIST,
};

export { getReviewerEmployeeKraKpiStatusListAction };
export default getReviewerEmployeeKraKpiStatusListSlice.reducer;
export const {setInitialStateOfgetReviewerEmployeeKraKpiStatusList} = getReviewerEmployeeKraKpiStatusListSlice.actions
